export default __webpack_public_path__ + "static/media/thomas.a4e10075.png";